import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useForm } from "react-hook-form";
import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { FaRegFile } from "react-icons/fa";
import { IoCheckbox } from "react-icons/io5";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useDocumentDeleteAPI } from "@/app/hooks/api_hooks/CertificateDocument/useDocumentDeleteAPI";
import { toast } from "react-hot-toast";
import { useDocumentListAPI } from "@/app/hooks/api_hooks/CertificateDocument/useDocumentListAPI";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ROUTES } from "@/app/routes";

export interface ICertificateDocumentUploadModalProps {
  documents?: File[];
  pet_name: string;
  certificate_type: string;
  certificate_id: string;
}

const CertificateDocumentDeleteModalContent = ({ data }) => {
  return (
    <div>
      <p className="text-sm font-medium">Are you sure you want to delete this File ?</p>
      <div className="border border-gray-300 p-4 rounded-2xl flex justify-between mt-3">
        <div className="flex items-center gap-2">
          <div className="text-[#737a89] text-xl">
            <FaRegFile />
          </div>
          <p className="text-sm">{data?.documents?.document_type}</p>
        </div>
        <IoCheckbox size="20" color="green" />
      </div>
    </div>
  );
};

const CertificateDocumentDeleteModal = () => {
  const { setInvisible } = useModalActions("CERTIFICATE_DOCUMENT_DELETE_MODAL");
  const modalState = useModalState("CERTIFICATE_DOCUMENT_DELETE_MODAL");
  const { execute: deleteDocument } = useDocumentDeleteAPI();
  const { execute: fetchDocumentList } = useDocumentListAPI();
  const { routeState } = useRouteInfo(ROUTES.ROOT.children.CUSTOMER_PROFILE.id);
  const { customerId } = routeState.state as ICustomerProfileState;

  const formHook = useForm<ICertificateDocumentUploadModalProps>({
    mode: "onChange",
    defaultValues: {
      documents: [],
    },
  });

  const handleSubmit = async () => {
    const payload = {
      document_id: modalState?.documents?.document_id,
    };
    try {
      const response = await deleteDocument(payload);
      if (response?.status) {
        setInvisible();
        toast.success("Document deleted successfully.");
        await fetchDocumentList(customerId);
      }
    } catch (error) {
      console.error("Delete Document error:", error);
    }
  };

  const handleClose = () => {
    setInvisible();
  };

  return (
    <ModalPrompt
      modalId="CERTIFICATE_DOCUMENT_DELETE_MODAL"
      showIcon={false}
      titleIcon=""
      dialogClassName="sm:my-8 sm:w-full sm:max-w-2xl sm:p-6"
      button={{
        primaryButtonText: "Delete",
        secondaryButtonText: "Cancel",
        primaryButtonClassname: `px-6 py-[9px] rounded-md border border-slate-400 border-opacity-20 justify-center items-center gap-2 flex cursor-pointer bg-red-500 hover`,
        primaryCallback: () => {
          handleSubmit();
        },
        secondaryCallback: () => {
          formHook.clearErrors();
          handleClose();
        },
      }}
      title="Delete Document"
      content={<CertificateDocumentDeleteModalContent data={modalState} />}
    />
  );
};

export default CertificateDocumentDeleteModal;
